import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../constants/constants';

export const componentKey = "MANAGE_FORMS/MANAGE_STATE_PAYROLL_FORMS";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },

        setStateNameList: (state, action) => {
            state.stateNameList = action.payload;
        },
        setSelectedStateName: (state, action) => {
            state.selectedStateName = action.payload;
        },

        setFormNameList: (state, action) => {
            state.formNameList = action.payload;
        },
        setSelectedFormName: (state, action) => {
            state.selectedFormName = action.payload;
        },

        setTaxYearList: (state, action) => {
            state.taxYearList = action.payload;
        },
        setSelectedTaxYear: (state, action) => {
            state.selectedTaxYear = action.payload;
        },

        setPayerList: (state, action) => {
            state.payerList = action.payload;
        },
        setSelectedPayer: (state, action) => {
            state.selectedPayer = action.payload;
        },

        setPaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },

        setManageFormsStatePayrollGridData: (state, action) => {
            state.manageFormsStatePayrollGridData = action.payload
        },

        setUrlFormIdParam: (state, action) => {
            state.urlFormIdParam = action.payload;
        },

        setUrlPayerIdParam: (state, action) => {
            state.urlPayerIdParam = action.payload;
        },

    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },

        stateNameList: [],
        selectedStateName: { label: "", value: "" },

        formNameList: [],
        selectedFormName: { label: "", value: "" },

        taxYearList: [],
        selectedTaxYear: { label: "", value: "" },

        payerList: [],
        selectedPayer: { label: "", value: "" },

        manageFormsStatePayrollGridData: [],

        paginationState: {
            PageNumber: 1,
            PageSize: 10,
            FilterText: "",
            IsDesc: true,
            IdNumber: "",
            Skip: 0,
            totalRecipients: 10,
        },

        urlFormIdParam: null,
        urlPayerIdParam: null,

    }
})
export const { setLoadingState, setStateNameList, setSelectedStateName, setFormNameList, setSelectedFormName, setTaxYearList, setSelectedTaxYear, setPayerList, setSelectedPayer, setPaginationState, setManageFormsStatePayrollGridData, setUrlFormIdParam, setUrlPayerIdParam } = actions; 